import { render } from "./CleanRoom.vue?vue&type=template&id=4ac82177&scoped=true"
const script = {}

import "./CleanRoom.vue?vue&type=style&index=0&id=4ac82177&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ac82177"

export default script